import moment from 'moment'

export default {
    name: 'courses-materials-item',
    props: {
        item: {
            type: Object,
            default: {}
        },
        typeUser: {
            type: String,
            default: 'speakers'
        },
        routeTo: {
            type: String,
            default: ''
        },
        typeImage: {
            type: String,
            default: 'image'
        },
        typeDescription: {
            type: String,
            default: 'description'
        },
        typeDate: {
            type: String,
            default: 'range'
        },
        hasCategories: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        formattedDate(item) {
            if (this.typeDate === 'range') {
                const date = moment(item.startedAt).format('DD MMMM, YYYY');
                const timeStart = moment(item.startedAt).format('HH:mm');
                if (item.hasOwnProperty('endedAt')) {
                    const timeEnd = moment(item.endedAt).format('HH:mm');
                    return `${date} · ${timeStart} ${' – ' + timeEnd}`
                } else {
                    return `${date} · ${timeStart}`
                }
            } else {
                return moment(item[this.typeDate]).format('DD MMMM, YYYY');
            }
        }
    }
}
